"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.hydrate = exports.preload = exports.getPreloadStrategy = exports.getNearPreloadDataUpdates = exports.setNearPreloadData = exports.getCurrentNearPreloadData = void 0;
var bignumber_js_1 = require("bignumber.js");
var rxjs_1 = require("rxjs");
var logs_1 = require("@ledgerhq/logs");
var api_1 = require("./api");
var logic_1 = require("./logic");
var errors_1 = require("./errors");
var PRELOAD_MAX_AGE = 30 * 60 * 1000;
var currentPreloadedData = {
    storageCost: new bignumber_js_1.BigNumber(logic_1.FALLBACK_STORAGE_AMOUNT_PER_BYTE),
    gasPrice: new bignumber_js_1.BigNumber(0),
    createAccountCostSend: new bignumber_js_1.BigNumber(0),
    createAccountCostExecution: new bignumber_js_1.BigNumber(0),
    transferCostSend: new bignumber_js_1.BigNumber(0),
    transferCostExecution: new bignumber_js_1.BigNumber(0),
    addKeyCostSend: new bignumber_js_1.BigNumber(0),
    addKeyCostExecution: new bignumber_js_1.BigNumber(0),
    receiptCreationSend: new bignumber_js_1.BigNumber(0),
    receiptCreationExecution: new bignumber_js_1.BigNumber(0),
    validators: []
};
function fromHydratePreloadData(data) {
    var hydratedData = Object.assign({}, currentPreloadedData);
    if (typeof data === "object" && data) {
        if (data.storageCost) {
            hydratedData.storageCost = new bignumber_js_1.BigNumber(data.storageCost);
        }
        if (data.gasPrice) {
            hydratedData.gasPrice = new bignumber_js_1.BigNumber(data.gasPrice);
        }
        if (data.createAccountCostSend) {
            hydratedData.createAccountCostSend = new bignumber_js_1.BigNumber(data.createAccountCostSend);
        }
        if (data.createAccountCostExecution) {
            hydratedData.createAccountCostExecution = new bignumber_js_1.BigNumber(data.createAccountCostExecution);
        }
        if (data.transferCostSend) {
            hydratedData.transferCostSend = new bignumber_js_1.BigNumber(data.transferCostSend);
        }
        if (data.transferCostExecution) {
            hydratedData.transferCostExecution = new bignumber_js_1.BigNumber(data.transferCostExecution);
        }
        if (data.addKeyCostSend) {
            hydratedData.addKeyCostSend = new bignumber_js_1.BigNumber(data.addKeyCostSend);
        }
        if (data.addKeyCostExecution) {
            hydratedData.addKeyCostExecution = new bignumber_js_1.BigNumber(data.addKeyCostExecution);
        }
        if (data.receiptCreationSend) {
            hydratedData.receiptCreationSend = new bignumber_js_1.BigNumber(data.receiptCreationSend);
        }
        if (data.receiptCreationExecution) {
            hydratedData.receiptCreationExecution = new bignumber_js_1.BigNumber(data.receiptCreationExecution);
        }
        if (Array.isArray(data.validators) && data.validators.length) {
            hydratedData.validators = data.validators;
        }
    }
    return hydratedData;
}
var updates = new rxjs_1.Subject();
function getCurrentNearPreloadData() {
    return currentPreloadedData;
}
exports.getCurrentNearPreloadData = getCurrentNearPreloadData;
function setNearPreloadData(data) {
    if (data === currentPreloadedData)
        return;
    currentPreloadedData = data;
    updates.next(data);
}
exports.setNearPreloadData = setNearPreloadData;
function getNearPreloadDataUpdates() {
    return updates.asObservable();
}
exports.getNearPreloadDataUpdates = getNearPreloadDataUpdates;
var getPreloadStrategy = function () { return ({
    preloadMaxAge: PRELOAD_MAX_AGE
}); };
exports.getPreloadStrategy = getPreloadStrategy;
var preload = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, protocolConfig, rawValidators, gasPrice, validators, _b, storage_amount_per_byte, transaction_costs, action_creation_config, action_receipt_creation_config;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                (0, logs_1.log)("near/preload", "preloading near data...");
                return [4 /*yield*/, Promise.all([
                        (0, api_1.getProtocolConfig)(),
                        (0, api_1.getValidators)(),
                        (0, api_1.getGasPrice)(),
                    ])];
            case 1:
                _a = __read.apply(void 0, [_c.sent(), 3]), protocolConfig = _a[0], rawValidators = _a[1], gasPrice = _a[2];
                return [4 /*yield*/, Promise.all(rawValidators.map(function (_a) {
                        var account_id = _a.account_id, stake = _a.stake;
                        return __awaiter(void 0, void 0, void 0, function () {
                            var commission;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, (0, api_1.getCommission)(account_id)];
                                    case 1:
                                        commission = _b.sent();
                                        return [2 /*return*/, {
                                                validatorAddress: account_id,
                                                tokens: stake,
                                                commission: commission
                                            }];
                                }
                            });
                        });
                    }))];
            case 2:
                validators = _c.sent();
                if (!protocolConfig) {
                    throw new errors_1.NearProtocolConfigNotLoaded();
                }
                _b = protocolConfig.runtime_config, storage_amount_per_byte = _b.storage_amount_per_byte, transaction_costs = _b.transaction_costs;
                action_creation_config = transaction_costs.action_creation_config, action_receipt_creation_config = transaction_costs.action_receipt_creation_config;
                return [2 /*return*/, {
                        storageCost: new bignumber_js_1.BigNumber(storage_amount_per_byte),
                        gasPrice: new bignumber_js_1.BigNumber(gasPrice),
                        createAccountCostSend: new bignumber_js_1.BigNumber(action_creation_config.create_account_cost.send_not_sir),
                        createAccountCostExecution: new bignumber_js_1.BigNumber(action_creation_config.create_account_cost.execution),
                        transferCostSend: new bignumber_js_1.BigNumber(action_creation_config.transfer_cost.send_not_sir),
                        transferCostExecution: new bignumber_js_1.BigNumber(action_creation_config.transfer_cost.execution),
                        addKeyCostSend: new bignumber_js_1.BigNumber(action_creation_config.add_key_cost.full_access_cost.send_not_sir),
                        addKeyCostExecution: new bignumber_js_1.BigNumber(action_creation_config.add_key_cost.full_access_cost.execution),
                        receiptCreationSend: new bignumber_js_1.BigNumber(action_receipt_creation_config.send_not_sir),
                        receiptCreationExecution: new bignumber_js_1.BigNumber(action_receipt_creation_config.execution),
                        validators: validators
                    }];
        }
    });
}); };
exports.preload = preload;
var hydrate = function (data) {
    var hydrated = fromHydratePreloadData(data);
    (0, logs_1.log)("near/preload", "hydrated storageCost with ".concat(hydrated.storageCost));
    setNearPreloadData(hydrated);
};
exports.hydrate = hydrate;
//# sourceMappingURL=preload.js.map